import { Routes } from "@angular/router";
import { HomePage } from "./pages/home-page/home-page";
import { HowItWorks } from "./pages/how-it-works/how-it-works";
import { Pricing } from "./pages/pricing/pricing";
import { Solutions } from "./pages/solutions/solutions";
import { Industry } from "./pages/solutions/industry";
import { Developers } from "./pages/developers/developers";
import { Faq } from "./pages/faq/faq";
import { About } from "./pages/about/about";
import { Security } from "./pages/security/security";
import { Contact } from "./pages/contact/contact";
import { Privacy } from "./pages/legal/privacy";
import { Terms } from "./pages/legal/terms";
import { BookACall } from "./pages/book-a-call/book-a-call";
import { Feedback } from "./pages/feedback/feedback";
import { NotFound } from "./pages/not-found/not-found";

export const routes: Routes = [
  {
    path: "",
    component: HomePage
  },
  {
    path: "how-it-works",
    component: HowItWorks
  },
  {
    path: "pricing",
    component: Pricing
  },
  {
    path: "solutions",
    component: Solutions
  },
  {
    path: "solutions/:industry",
    component: Industry
  },
  {
    path: "developers",
    component: Developers
  },
  {
    path: "resources",
    loadComponent: () => import("./pages/resources/resources").then(m => m.Resources)
  },
  {
    path: "resources/:slug",
    loadComponent: () => import("./pages/resources/article").then(m => m.ArticlePage)
  },
  {
    path: "faq",
    component: Faq
  },
  {
    path: "about",
    component: About
  },
  {
    path: "security",
    component: Security
  },
  {
    path: "contact",
    component: Contact
  },
  {
    path: "book-a-call",
    component: BookACall
  },
  {
    path: "feedback",
    component: Feedback
  },
  {
    path: "privacy",
    component: Privacy
  },
  {
    path: "terms",
    component: Terms
  },
  {
    path: "account",
    loadChildren: () => import("./pages/account/account.routes").then(m => m.accountRoutes)
  },
  {
    path: "dashboard",
    loadChildren: () => import("./pages/dashboard/dashboard.routes").then(m => m.dashboardRoutes)
  },
  {
    path: "admin",
    loadChildren: () => import("./pages/admin/admin.routes").then(m => m.adminRoutes)
  },
  {
    path: "404",
    component: NotFound
  },
  {
    path: "**",
    component: NotFound
  }
];
